import { NgModule }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { RouterModule } from '@angular/router';

import { JwtModule } from '@auth0/angular-jwt';
import { AngularMaterialModule } from '../angular-material.module';

import { AuthzoneComponent } from './authzone.component';
import { AuthzoneSideMenuComponent } from './authzone-side-menu/authzone-side-menu.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    RouterModule  ],
  declarations: [
    AuthzoneComponent,
    AuthzoneSideMenuComponent
  ],
  exports:      [ AuthzoneComponent, AuthzoneSideMenuComponent ],
  providers:    [ ]
})

export class AuthzoneModule { }
